import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { PopupIds } from 'store/UIStore/Popups';

import css from './Controls.module.css';

const Controls = () => {
  const {
    app: { i18n },
    ui,
    filter,
    savedFilters,
  } = useStore();

  const handleSaveAsFilter = async () => {
    const isLoggedIn = window.atiUser?.is_user;
    if (isLoggedIn) {
      await savedFilters.openFilterPopup();
    } else {
      ui.popups.open(PopupIds.loginPopup);
    }
  };

  return (
    <div className={css.container}>
      {!filter.isDefault && (
        <button
          className={cn(css.button, 'glz-link', ' glz-is-medium', 'glz-is-gray', 'glz-is-dashed')}
          role="presentation"
          onClick={filter.root.clearFilter}
        >
          {i18n.app.clearForm}
        </button>
      )}

      {savedFilters.canSaveFilter &&
        (filter.savedFilter ? (
          <button
            className={cn(css.button, 'glz-link glz-is-medium glz-is-bold glz-is-dashed')}
            onClick={async () => await savedFilters.openFilterPopup(filter?.savedFilter?.savedFilter)}
          >
            <Icon className="glz-before-icon" color="currentColor" height={15} name="ic_check-bold" width={15} />
            {i18n.app.filterSaved}
          </button>
        ) : (
          <button
            className={cn(
              css.button,
              'glz-link',
              'glz-is-medium',
              'glz-is-primary',
              'glz-is-dashed',
              'glz-tooltip',
              'glz-is-position-top',
            )}
            onClick={handleSaveAsFilter}
          >
            {i18n.app.saveAsFilter}
          </button>
        ))}
    </div>
  );
};

const connected = observer(Controls);

export { connected as Controls };
